import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";

import { getLayoutById, resetHistory } from "../store/ducks/duckLayout";
import LoadingComponent from "../components/LoadingComponent";
import { getFavorites } from "../store/ducks/duckFavorites";
import { mstrPath } from "../mstrApp/utils/mstrBase";

import LayoutWithTabs from "./LayoutWithTabs";
import LayoutSimple from "./LayoutSimple";

const LEGACY_MSTR_HOST = "mstrprd.teic.techint.net";

const TAB_VALUE_TO_DOSSIER_KEY = {
  pl: "PL",
  "p&l": "PL",
  revenue: "Revenue",
  "gross mg": "Gross Mg",
  grossmg: "Gross Mg",
  "gross margin": "Gross Mg",
  grossmargin: "Gross Mg",
  acquisitions: "Acquisitions",
  backlog: "Backlog",
  projects: "Projects",
};

const normalizeTabValue = (value) => String(value || "").trim().toLowerCase().replace(/\s+/g, "");

const LEGACY_DOCUMENT_TO_DOSSIER_KEY = {
  "67C3610949981F8074A9F8B165C7937C": "PL",
  BFD983A44A74865A4CC77BA740EBACE2: "Revenue",
  "9CABBE5149A3C6F44761D6A314B860BE": "Gross Mg",
  "664A5411435311EF771C4EA98EA2A89F": "Acquisitions",
  "3D6C9E35490C11752FAA02B924DCF99A": "Backlog",
  "32DA6DF6476846F0EE91BEBE2746E393": "Projects",
};

const isLegacyMstrSource = (url) => typeof url === "string" && url.includes(LEGACY_MSTR_HOST);

const getLegacyDocumentId = (url) => {
  if (!isLegacyMstrSource(url)) return null;

  const match = url.match(/[?&]documentID=([^&]+)/i);

  return match ? match[1] : null;
};

const ProviderLayout = () => {
  const dispatch = useDispatch();

  const { id } = useParams();

  const { tabs, source } = useSelector((state) => state.layout.layoutSelected);

  const { isLoading } = useSelector((state) => state.layout);
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  useEffect(() => {
    dispatch(getLayoutById(id));
    dispatch(getFavorites());

    return () => dispatch(resetHistory()); //Se resetea la historia entre layouts
  }, [dispatch, enqueueSnackbar, history, id]);

  useEffect(() => {
    const legacyTab = (tabs || []).find((tab) => isLegacyMstrSource(tab?.sourceUrl));
    const legacyUrl = legacyTab?.sourceUrl || (isLegacyMstrSource(source) ? source : null);

    if (!legacyUrl) return;

    const tabKey = normalizeTabValue(legacyTab?.tabValue);
    const dossierKey =
      TAB_VALUE_TO_DOSSIER_KEY[tabKey] ||
      TAB_VALUE_TO_DOSSIER_KEY[String(legacyTab?.tabValue || "").trim().toLowerCase()] ||
      LEGACY_DOCUMENT_TO_DOSSIER_KEY[getLegacyDocumentId(legacyUrl)];

    if (!dossierKey) return;

    history.replace(mstrPath(`embedding?dossier=${encodeURIComponent(dossierKey)}`));
  }, [history, source, tabs]);

  if (isLoading !== undefined) {
    if (isLoading) {
      return <LoadingComponent loading={isLoading} />;
    } else if (id === "1") {
      if (tabs !== undefined && tabs.length > 0) {
        return <LayoutWithTabs />;
      } else {
        return <LoadingComponent loading={isLoading} />;
      }
    } else if (tabs && !isLoading) {
      return <LayoutWithTabs />;
    } else if (!isLoading && !tabs) {
      return <LayoutSimple />;
    } else {
      return <LoadingComponent loading={true} />;
    }
  } else {
    return <LoadingComponent loading={true} />;
  }
};

export default React.memo(ProviderLayout);
